import React, { useState, useEffect, useCallback } from 'react';
import { Users, Check, X, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { eur } from '../ExpenseDetail/DetailKpis';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}`, 'Content-Type': 'application/json' });

const GroupCard = ({ group, onDone }) => {
  const [canonical, setCanonical] = useState(group.suggested);
  const [busy, setBusy] = useState('');
  const members = group.members.map(m => m.name);

  const post = async (path, body, kind) => {
    setBusy(kind);
    try {
      const res = await fetch(`${API_URL}/api/admin/gastos/proveedores/${path}`, { method: 'POST', headers: headers(), body: JSON.stringify(body) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.detail || 'Error');
      toast.success(kind === 'merge' ? `Unificado como "${canonical}" (${j.updated_expenses} gastos)` : 'Marcados como distintos');
      onDone();
    } catch (e) {
      toast.error(e.message);
      setBusy('');
    }
  };

  return (
    <div className="bg-white rounded-lg p-3 space-y-2" data-testid={`vendor-group-${group.group_id}`}>
      <p className="text-xs text-gray-500">Elige el nombre correcto:</p>
      {group.members.map((m, i) => (
        <label key={m.name} className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="radio" checked={canonical === m.name} onChange={() => setCanonical(m.name)} data-testid={`vendor-group-option-${i}`} />
          <span className="font-medium text-gray-900 flex-1 min-w-0 truncate">{m.name}</span>
          <span className="text-xs text-gray-400 shrink-0">{m.count} gastos · {eur(m.total)}{m.nifs.length ? ` · ${m.nifs.join(', ')}` : ''}</span>
        </label>
      ))}
      <div className="flex gap-2 pt-1">
        <button onClick={() => post('unificar', { canonical, members }, 'merge')} disabled={!!busy}
          className="flex-1 h-9 rounded-lg bg-gray-900 text-white text-sm font-semibold flex items-center justify-center gap-1.5 disabled:opacity-50"
          data-testid="vendor-group-merge-btn">
          {busy === 'merge' ? <RefreshCw size={14} className="animate-spin" /> : <Check size={14} />} Unir
        </button>
        <button onClick={() => post('ignorar', { members }, 'ignore')} disabled={!!busy}
          className="h-9 px-3 rounded-lg border text-sm text-gray-600 flex items-center gap-1.5 hover:bg-gray-50 disabled:opacity-50"
          data-testid="vendor-group-ignore-btn">
          <X size={14} /> No son el mismo
        </button>
      </div>
    </div>
  );
};

export const VendorDuplicates = ({ onMerged }) => {
  const [groups, setGroups] = useState([]);

  const load = useCallback(() => {
    fetch(`${API_URL}/api/admin/gastos/proveedores/duplicados`, { headers: headers() })
      .then(r => (r.ok ? r.json() : { groups: [] }))
      .then(j => setGroups(j.groups || []))
      .catch(() => setGroups([]));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!groups.length) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 space-y-2" data-testid="vendor-duplicates">
      <p className="font-semibold text-blue-900 text-sm flex items-center gap-2">
        <Users size={17} /> {groups.length} proveedor{groups.length > 1 ? 'es' : ''} con varios nombres
      </p>
      {groups.map(g => <GroupCard key={g.group_id} group={g} onDone={() => { load(); onMerged?.(); }} />)}
    </div>
  );
};
